import React, { ReactElement, useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { fromNowToEndDate } from '../../../../common/utils/utils';
import { ResponseEvent } from '../../../../services/api/models/response/responseEvent';
import { LiveProps } from '../../LiveContainer';

interface LiveEventItemProps {
  liveProps: LiveProps;
  event: ResponseEvent;
}

export const LiveEventItem = (props: LiveEventItemProps): ReactElement => {
  const [countDownTime, setCountDownTime] = useState('--:--');

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const endDate = new Date(props.event.endDateTime);
      if (now > endDate) {
        clearInterval(timer);
        setCountDownTime('終了しました');
        return;
      }
      setCountDownTime(fromNowToEndDate(props.event?.endDateTime));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="live-event-banner__item">
      <Image
        src={props.event?.icon?.uri}
        onClick={() => {
          props.liveProps.showEventModal(props.event);
        }}
        className="live-event-banner__icon"
      ></Image>
      <div className="live-event-banner__countdown">{countDownTime}</div>
    </div>
  );
};
